<template>
  <!-- 关于我们 -->
  <div class="about_us">
    <!--横幅图-->
    <div class="new_banner" :style="'background-image:url('+top+')'">
      <p>为园区向“地产+”平台生态圈的转型发展</p>
      <p>提供全方位产业赋能服务</p>
    </div>
    <div class="content">
      <div class="content_nav">
        <router-link to="/about_us" :class="{router_link_active:$route.path.indexOf('about_us')>-1}">关于我们</router-link>
        <router-link to="/breaking_news" :class="{router_link_active:$route.path.indexOf('breaking_news')>-1}">大事件</router-link>
      </div>
      <div class="content_wrapper">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/assets/img/about_us/top.png";
export default {
  data(){
    return{
      top:top
    }
  }
}
</script>

<style lang="scss" scoped>
.about_us{
  height: 100%;
  background-color: #fff;
  .new_banner {
    height: 300px;
    background-color: $bg-darkgray;
    background-size: 100% 100%;
    padding-top: 100px;
    box-sizing: border-box; 
    // display: table-cell;
    p{
      font-size:30px;
      font-weight:bold;
      color:rgba(255,255,255,1);
      line-height:49px;
      text-align: center;
      // vertical-align: middle;
    }
  }
  .content{
    .content_nav{
      border-bottom: 1px solid rgba(238,238,238,1);
      text-align: center;
      a{
        font-size:14px;
        color:rgba(153,153,153,1);
        line-height: 60px;
      }
      a:first-of-type{
        margin-right: 100px;
      }
      .router_link_active{
        font-size:14px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        border-bottom: 3px solid black;
        padding-bottom: 20px;
        // border-bottom-width: 24px;
      }
    }
  }
}
</style>